export const NI_RATES_2025_26 = {
  EMPLOYEE_THRESHOLD_MONTHLY: 1048,
  EMPLOYEE_UPPER_THRESHOLD_MONTHLY: 4189,
  EMPLOYER_THRESHOLD_MONTHLY: 417, // Updated from £758 to £417 for 2025-26
  EMPLOYEE_RATE_STANDARD: 0.08, // Corrected from 0.12 to 0.08
  EMPLOYEE_RATE_UPPER: 0.02,
  EMPLOYER_RATE: 0.15, // Updated from 0.138 to 0.15 for 2025-26
};

export function calculateEmployeeNI(grossMonthlySalary, pensionContribution = 0) {
  const taxableIncome = grossMonthlySalary - pensionContribution;
  const { EMPLOYEE_THRESHOLD_MONTHLY, EMPLOYEE_UPPER_THRESHOLD_MONTHLY, EMPLOYEE_RATE_STANDARD, EMPLOYEE_RATE_UPPER } = NI_RATES_2025_26;
  
  if (taxableIncome <= EMPLOYEE_THRESHOLD_MONTHLY) {
    return 0;
  }
  
  let ni = 0;
  
  // 8% on earnings between £1,048 and £4,189
  const standardRatePortion = Math.min(taxableIncome, EMPLOYEE_UPPER_THRESHOLD_MONTHLY) - EMPLOYEE_THRESHOLD_MONTHLY;
  ni += standardRatePortion * EMPLOYEE_RATE_STANDARD;
  
  // 2% on earnings above £4,189
  if (taxableIncome > EMPLOYEE_UPPER_THRESHOLD_MONTHLY) {
    const upperRatePortion = taxableIncome - EMPLOYEE_UPPER_THRESHOLD_MONTHLY;
    ni += upperRatePortion * EMPLOYEE_RATE_UPPER;
  }
  
  return ni;
}

export function calculateEmployerNI(grossMonthlySalary) {
  const { EMPLOYER_THRESHOLD_MONTHLY, EMPLOYER_RATE } = NI_RATES_2025_26;
  
  if (grossMonthlySalary <= EMPLOYER_THRESHOLD_MONTHLY) {
    return 0;
  }
  
  return (grossMonthlySalary - EMPLOYER_THRESHOLD_MONTHLY) * EMPLOYER_RATE;
}

export function calculateNationalInsurance(grossMonthlySalary, pensionContribution = 0) {
  const employeeNI = calculateEmployeeNI(grossMonthlySalary, pensionContribution);
  const employerNI = calculateEmployerNI(grossMonthlySalary);
  
  return {
    employeeNI,
    employerNI,
    totalNI: employeeNI + employerNI,
  };
}